<template>
    <div class="top_container">
        <div class="px-sm py-xs grid w-full grid-cols-4 content-center rounded-sm bg-(--state-success-bg)">
            <div class="flex items-center">
                Status
                <TagComponent
                    :value="status ?? ''"
                    :variant="status === 'FINISHED' ? 'success' : status === 'WAITING FOR APPROVAL' ? 'danger' : status === 'IN PROGRESS' ? 'warning' : 'default'"
                    :show-dot="true"
                    class-name="mx-xs"
                />
            </div>

            <div class="flex items-center">
                Responsible admin
                <TagComponent :value="admin ?? ''" variant="info" :show-dot="true" class-name="mx-xs" />
            </div>

            <div class="gap-sm flex items-center">
                Next Step
                <TagComponent
                    :value="nextStep ?? ''"
                    :variant="nextStep === 'Summary' || nextStep === 'Review' ? 'hold' : nextStep === 'Role Pool' ? 'info' : 'default'"
                    class-name="text-md capitalize"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import TagComponent from '@/components/ui/tag/TagComponent.vue';

const props = defineProps({
    status: String,
    nextStep: String,
});

const admin = ref('');

onMounted(() => {
    if (props.status === 'WAITING FOR APPROVAL') {
        admin.value = 'NOC';
    } else {
        admin.value = 'CDIM';
    }
});
</script>

<style scoped>
@reference '@/assets/styles/default.css';

.top_container {
    position: absolute;
    top: var(--spacing-md);
    width: calc(8 / 12 * 100%);
    display: flex;
    padding: 0 var(--spacing-md);
    box-sizing: border-box;
}
</style>
